import { destinationMapAPIClient } from '@/scopes/common/infrastructure/api/destination-map'
import { useQuery } from '@tanstack/react-query'

export function useAccoDetailsById(accoId: string) {
  const { data, isLoading } = useQuery({
    queryFn: () => {
      return destinationMapAPIClient.getAccoDetails({ accoId })
    },
    queryKey: ['acco-details', accoId],
  })
  return {
    accoDetails: data,
    isLoading,
  }
}
